export const it = {
    app: { name: "ComUnica Lab", tagline: "Pratiche Camerali Conversazionali" },
    nav: {
        chat: "Chat AI",
        clients: "Anagrafica Clienti",
        pratiche: "Moduli",
        pivaAde: "ComUnica / Registro Imprese",
        moduleDemo: "Prova",
        toSend: "Da inviare",
        sent: "Inviate",
        templates: "Modelli",
        telematico: "Invio Telematico",
        credits: "Crediti",
        admin: "Amministrazione",
        affiliates: "Affiliati",
        pricing: "Listino prezzi",
        stats: "Statistiche",
        logout: "Esci",
        settings: "Impostazioni",
        account: "Account",
        userProfile: "Anagrafica Utente",
        entratel: "Entratel",
        telemaco: "Telemaco",
        payments: "Pagamenti",
        paymentProvider: "Provider",
        affiliateCredits: "Accrediti Affiliati",
        paymentCredits: "Crediti",
        creditGeneralSettings: "Impostazione Crediti Generale",
        tariffario: "Tariffario",
    },
    auth: {
        loginTitle: "Accedi a ComUnica Lab",
        loginSubtitle: "Laboratorio per la predisposizione guidata di pratiche camerali.",
        registerTitle: "Crea il tuo account",
        registerSubtitle: "Registrati come affiliato e inizia subito.",
        email: "Email",
        password: "Password",
        fullName: "Nome e cognome",
        loginBtn: "Accedi",
        registerBtn: "Registrati",
        noAccount: "Non hai un account?",
        hasAccount: "Hai già un account?",
        registerLink: "Registrati",
        loginLink: "Accedi",
        loginError: "Credenziali non valide",
        serverWaking: "Il server si sta avviando, attendi qualche secondo e riprova. Le tue credenziali sono corrette.",
        registerError: "Errore nella registrazione",
    },
    chat: {
        welcomeTitle: "Buongiorno",
        welcomeSubtitle: "Descrivi la pratica camerale che vuoi predisporre.",
        placeholder: "Descrivi la pratica o allega visura, atto o documento...",
        send: "Invia",
        newChat: "Nuova conversazione",
        attach: "Allega documento",
        suggested: [
            { title: "Iscrizione impresa", body: "Voglio predisporre l’iscrizione al Registro Imprese di una nuova società." },
            { title: "Variazione sede", body: "Devo comunicare la variazione della sede legale di una società." },
            { title: "Cessazione impresa", body: "Voglio predisporre una pratica di cessazione al Registro Imprese." },
            { title: "Pratica con SUAP", body: "Devo predisporre una ComUnica con SCIA contestuale per il SUAP." },
        ],
        emptyConversations: "Nessuna conversazione",
        confirmDelete: "Eliminare questa conversazione?",
        creditsCharged: "Crediti utilizzati",
    },
    clients: {
        title: "Anagrafica Clienti",
        subtitle: "Gestisci i tuoi clienti e le loro informazioni fiscali.",
        newClient: "Nuovo cliente",
        search: "Cerca per nome, CF o P.IVA...",
        empty: "Nessun cliente registrato",
        editClient: "Modifica cliente",
        createClient: "Crea cliente",
        save: "Salva",
        cancel: "Annulla",
        confirmDelete: "Eliminare definitivamente questo cliente?",
        fields: {
            codice_fiscale: "Codice Fiscale",
            cognome: "Cognome",
            nome: "Nome",
            sesso: "Sesso",
            data_nascita: "Data di nascita",
            comune_nascita: "Comune di nascita",
            provincia_nascita: "Provincia di nascita",
            cittadinanza: "Cittadinanza",
            email: "Email",
            telefono: "Telefono",
            comune_residenza: "Comune di residenza",
            provincia_residenza: "Provincia",
            cap_residenza: "CAP",
            indirizzo_residenza: "Indirizzo",
            civico_residenza: "Civico",
            partita_iva: "Partita IVA",
            notes: "Note",
        },
    },
    pratiche: {
        title: "Moduli",
        subtitle: "Gestione modulare degli adempimenti disponibili.",
        modulePivaAdeTitle: "P. IVA AdE",
        modulePivaAdeSubtitle: "Apertura, variazione e cessazione Partita IVA con invio Agenzia Entrate.",
        newPratica: "Nuova pratica camerale",
        empty: "Nessuna pratica ancora",
        emptyHint: "Inizia una conversazione per generare la prima bozza ComUnica.",
        status: {
            draft: "Bozza",
            review: "In revisione",
            ready: "Pronta per invio",
            submitted: "Inviata",
            accepted: "Accettata",
            rejected: "Scartata",
        },
        validate: "Valida",
        generate: "Salva",
        download: "Scarica file tecnico",
        markSubmitted: "Segna come inviata",
        savedReady: "Pratica salvata e pronta per l'invio all'Agenzia delle Entrate.",
        delete: "Elimina pratica",
        deleteConfirm: "Eliminare definitivamente questa pratica?",
        deleteSelected: "Elimina selezionate",
        sendSelected: "Invia selezionate",
        selectedCount: "selezionate",
        instructionsTitle: "Come inviare a Desktop Telematico",
        instructions: [
            "Apri Desktop Telematico (Agenzia delle Entrate) sul tuo PC.",
            "Vai nel modulo «File Internet» → «Controlla file».",
            "Carica il file .ccf scaricato.",
            "Esegui «Prepara file» con il tuo certificato Entratel.",
            "Seleziona «Invia» e attendi la ricevuta di protocollo.",
            "Torna qui e clicca «Segna come inviata» inserendo il numero di protocollo.",
        ],
    },
    calc: {
        button: "Calcola automaticamente",
        done: "Calcoli eseguiti e salvati nei quadri",
        summaryTitle: "Riepilogo calcoli",
        disclaimer: "Calcolo indicativo (aliquote e detrazioni 2025/2026 in forma semplificata). Verifica sempre i risultati prima dell'invio.",
        f24Button: "Genera F24",
        f24Created: "F24 creato dalla dichiarazione",
    },
    precompilata: {
        title: "Dichiarazione precompilata",
        subtitle: "Recupera i dati della precompilata AdE: tramite delega intermediario (canale telematico) oppure carica il file scaricato dal contribuente con SPID.",
        viaDelega: "Richiedi via delega intermediario",
        viaSpid: "Ho la precompilata (SPID)",
        richiestaStarted: "Richiesta inviata al canale telematico! Segui l'avanzamento in Invio Telematico.",
        importing: "Estrazione dati dalla precompilata in corso...",
        imported: "Dati importati nella pratica",
        received: "Precompilata ricevuta dal canale telematico — disponibile nell'archivio server.",
        uploadBtn: "Carica file precompilata (XML o PDF)",
        spidTitle: "Come recuperare la precompilata con SPID",
        spidSteps: [
            "Il contribuente accede a www.agenziaentrate.gov.it → «Dichiarazione precompilata» con SPID/CIE/CNS.",
            "Dalla sezione «Visualizza dichiarazione» scarica il PDF o l'XML della precompilata.",
            "Fatti inviare il file e caricalo qui sotto: l'AI estrarrà automaticamente i dati nei quadri.",
        ],
    },
    templates: {
        title: "Modelli",
        empty: "Nessun modello salvato",
        emptyHint: "Apri una pratica e clicca «Salva come modello» per riutilizzarla in futuro.",
        use: "Usa modello",
        global: "Globale",
        duplicate: "Duplica pratica",
        duplicated: "Pratica duplicata! Ora stai lavorando sulla copia.",
        saveAs: "Salva come modello",
        saved: "Modello salvato! Lo trovi in Moduli → P. IVA AdE → Modelli.",
        namePrompt: "Nome del modello:",
        globalPrompt: "Rendere questo modello GLOBALE (visibile a tutti gli affiliati)?",
        confirmDelete: "Eliminare definitivamente questo modello?",
        deleted: "Modello eliminato",
        createdFromTemplate: "Pratica creata dal modello!",
    },
    telematico: {
        title: "Invio Telematico",
        subtitle: "Invio automatico delle pratiche all'Agenzia delle Entrate (canale Entratel/Fisconline).",
        tabInvii: "Invii",
        tabSettings: "Impostazioni",
        empty: "Nessun invio effettuato",
        emptyHint: "Genera una pratica e clicca «Invia all'AdE» per avviare l'invio automatico.",
        installed: "Desktop Telematico installato sul server — produzione disponibile",
        notInstalled: "Desktop Telematico non installato sul server",
        simulationNote: "Produzione non disponibile: installa/configura Desktop Telematico o Entratel-Multifile sul server.",
        simBadge: "Test isolato",
        protocol: "Protocollo",
        ricevutaOfficial: "Ricevuta ufficiale AdE",
        ricevutaAvailableHint: "PDF generato dal file .rel ufficiale, con esito e motivazione di eventuale scarto.",
        downloadRicevuta: "Scarica ricevuta PDF",
        downloadRel: "Scarica file .rel",
        ricevutaDownloaded: "Ricevuta inviata al browser",
        esitoLabel: "Esito ufficiale",
        esito: {
            ACCOLTA: "Accolta",
            SCARTATA: "Scartata",
            IN_ELABORAZIONE: "In elaborazione",
        },
        fetchRicevuta: "Recupera ricevuta AdE",
        ricevutaFetched: "Ricevuta ufficiale acquisita",
        confirmInvio: "Conferma trasmissione all'AdE",
        confirmInvioPrompt: "Confermi la TRASMISSIONE DEFINITIVA di questo file all'Agenzia delle Entrate? L'operazione non è annullabile.",
        invioConfermato: "Trasmissione confermata: invio in corso",
        diag: {
            title: "Diagnostica comandi Entratel-Multifile",
            workDir: "Cartella lavoro",
            runAs: "Utente exec",
            notConfigured: "non configurato (fallback script Desktop Telematico)",
            missing: "NON TROVATO",
            notExecutable: "NON ESEGUIBILE",
            mock: "MOCK/STUB — non valido per la modalità reale",
            writable: "scrivibile",
            notWritable: "NON SCRIVIBILE",
        },
        blockedTitle: "Modalità reale BLOCCATA",
        confirmModal: {
            title: "Conferma trasmissione definitiva",
            warning: "Stai per trasmettere DEFINITIVAMENTE questo file all'Agenzia delle Entrate. L'operazione non è annullabile.",
            model: "Modello",
            pratica: "Pratica",
            authFile: "File autenticato",
            size: "Dimensione",
            missingAuth: "File autenticato non disponibile: impossibile procedere con la trasmissione.",
            cancel: "Annulla",
            continueBtn: "Continua",
            typePrompt: "Per confermare la trasmissione, digita INVIA:",
            confirmBtn: "Conferma e trasmetti",
            starting: "Trasmissione in avvio…",
        },
        retry: "Riprova invio",
        retryStarted: "Invio ritentato",
        sendToAde: "Invia all'AdE",
        sendStarted: "Invio definitivo avviato. Segui controllo/autentica/trasmissione/ricevuta nella sezione Invio Telematico.",
        status: {
            queued: "In coda",
            controllo: "Controllo",
            autentica: "Autentica",
            invio: "Trasmissione",
            ricevuta: "Ricevuta",
            awaiting_confirmation: "Conferma disabilitata",
            completed: "Completato",
            failed: "Fallito",
        },
        environment: {
            title: "Ambiente sicurezza cloud",
            ready: "Ambiente sicurezza caricato: UTEF.P12 e UTEC.P12 presenti",
            missing: "Ambiente sicurezza non completo",
            pathHint: "Carica qui i certificati dell'affiliato: saranno salvati in area cloud isolata.",
            uploadBtn: "Carica file",
            uploaded: "Ambiente sicurezza caricato",
            allowed: "File ammessi: UTEF.P12, UTEC.P12, UTENTE.KS, ENTRATEL.txt. Password e PIN restano nei campi cifrati separati.",
        },
        settingsForm: {
            credentialsSection: "Credenziali Entratel / Fisconline",
            tipoUtente: "Tipo utenza",
            utente: "Codice utente",
            password: "Password",
            passwordHint: "Password di ACCESSO ai servizi telematici (quella \"corta\" del login, usata con il PIN in fase di invio)",
            pin: "PIN",
            pinHint: "PIN dispositivo dell'utenza (usato in fase di invio)",
            sede: "Sede utenza",
            sedeHint: "Progressivo sede dell'utenza Entratel/Fisconline principale. Di solito 000.",
            cfIntermediario: "Codice fiscale intermediario",
            cfIntermediarioHint: "Dato anagrafico/intermediario usato da FiscoAI; non sostituisce i campi incaricante di Desktop Telematico.",
            invioPer: "Modalità soggetto incaricante (come Desktop Telematico)",
            contoProprio: "Invio da effettuare per conto proprio",
            contoAltro: "Invio da effettuare per conto di un altro soggetto dal quale si è stati incaricati",
            incaricanteUtente: "Utente / CF incaricante",
            incaricanteUtenteHint: "Campo 'Utente' nel secondo blocco di Desktop Telematico.",
            incaricanteSede: "Sede incaricante",
            incaricanteSedeHint: "Campo 'Sede' nel secondo blocco di Desktop Telematico.",
            envPath: "Percorso ambiente di sicurezza (certificato)",
            envPassword: "Password ambiente di sicurezza",
            envPasswordHint: "Password di PROTEZIONE dell'ambiente di sicurezza (quella \"lunga\" scelta alla generazione dei certificati, usata in fase di autentica/firma)",
            modeSection: "Modalità di invio",
            modeSim: "Test isolato",
            modeSimDesc: "Modalità riservata ai test interni, non disponibile agli affiliati.",
            modeReal: "Produzione Entratel-Multifile",
            modeRealDesc: "Usa gli script ufficiali AdE installati sul server per trasmettere realmente i file.",
            modePreinvio: "Pre-invio test isolato",
            modePreinvioDesc: "Modalità riservata ai test interni, non disponibile agli affiliati.",
            modeProduction: "Produzione",
            modeProductionDesc: "Il click SaaS «Invia all'AdE» avvia controllo ufficiale, autentica, trasmissione reale e recupero ricevuta.",
            modeRealDisabled: "Non disponibile: Desktop Telematico/Entratel-Multifile non configurato sul server.",
        },
        saved: "Impostazioni salvate",
    },
    credits: {
        title: "Crediti",
        balance: "Saldo crediti",
        topup: "Ricarica crediti",
        history: "Storico transazioni",
        equivalentEur: "1 credito = 1 €",
        choosePackage: "Scegli un pacchetto",
        proceedToPay: "Procedi al pagamento",
        paymentSuccess: "Pagamento confermato!",
        paymentSuccessHint: "I crediti sono stati aggiunti al tuo saldo.",
        paymentCancel: "Pagamento annullato",
        paymentCancelHint: "Nessun addebito è stato effettuato.",
        backToCredits: "Torna ai crediti",
        emptyTx: "Nessuna transazione",
    },
    admin: {
        affiliates: "Gestione Affiliati",
        affiliatesSubtitle: "Crea, modifica e gestisci i crediti dei tuoi affiliati.",
        pricing: "Listino prezzi",
        pricingSubtitle: "Modifica i crediti richiesti per ogni tipologia di pratica.",
        stats: "Statistiche",
        statsSubtitle: "Panoramica della piattaforma e dei consumi.",
        newAffiliate: "Nuovo affiliato",
        active: "Attivo",
        disabled: "Disattivato",
        editPrice: "Modifica prezzo",
        savePrice: "Salva",
        statusActive: "Attivo",
        statusComingSoon: "In arrivo",
        statusIntegration: "Integrazione",
        statusDisabled: "Disabilitato",
        kpi: {
            affiliates: "Affiliati attivi",
            clients: "Clienti totali",
            pratiche: "Pratiche totali",
            submitted: "Pratiche inviate",
            credits: "Crediti in circolo",
            revenue: "Fatturato (€)",
        },
    },
    common: {
        loading: "Caricamento...",
        save: "Salva",
        cancel: "Annulla",
        delete: "Elimina",
        edit: "Modifica",
        confirm: "Conferma",
        close: "Chiudi",
        searching: "Ricerca...",
        you: "Tu",
        ai: "FiscoAI",
        creditsLeft: "Crediti",
    },
};
